import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-list-repair",
  "use": "icon-ic-list-repair-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-list-repair\"><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0zm0 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm3.23-11.22-2-2.07 2.93-3a4.48 4.48 0 0 0-6.06 5.65l-4.57 4.55a.632.632 0 0 0 .07 1l1.57 1.58a.649.649 0 0 0 1 0l4.53-4.51a4.33 4.33 0 0 0 4.7-1 4.48 4.48 0 0 0 .89-5.1l-3.06 2.9z\" fill=\"#323337\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol